import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import ContactUs from "./ContactUs";
import Posts from "./Posts";
import Event from "./Event";
import ViewDetailsEvents from "../posts/ViewDetailsEvents";
import Vendor from "./Vendor";
import CompanyPreview from "../leads/CompanyPreview";
import EventPreview from "../leads/EventPreview";
import HospitalPreview from "../leads/HospitalPreview";
// import Booking from "./Booking";
// import BookingFormDownload from "./BookingFormDownload";

const ViewBooking = lazy(() => import("../Booking/ViewBooking"));
const ViewDetails =lazy(()=>import('../../Portals/Enquiries/ViewDetails'))
const ViewDetailsPosts =lazy(() =>import('../posts/ViewDetails'))
const EnquiriesModule = () => {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="contactus" element={<ContactUs />} />
        <Route path="posts" element={<Posts />} />
        <Route path="events" element={<Event />} />
        <Route path="vendors" element={<Vendor />} />
        <Route path="posts/viewDetailsPosts" element={<ViewDetailsPosts />} />
        <Route path="events/viewDetailsEvents" element={<ViewDetailsEvents />} />
         <Route path="contactus/ViewDetails" element={<ViewDetails />} />
         <Route path="contactus/previewCompany" element={<CompanyPreview />} />
         <Route path="contactus/previewHospital" element={<HospitalPreview />} />
         <Route path="contactus/eventPreview" element={<EventPreview />} />
         <Route path="posts/ViewDetails" element={<ViewDetails />} />
         <Route path="posts/previewCompany" element={<CompanyPreview />} />
         <Route path="posts/previewHospital" element={<HospitalPreview />} />
         <Route path="posts/eventPreview" element={<EventPreview />} />
         <Route path="events/ViewDetails" element={<ViewDetails />} />
         <Route path="events/previewCompany" element={<CompanyPreview />} />
         <Route path="events/previewHospital" element={<HospitalPreview />} />
         <Route path="events/eventPreview" element={<EventPreview />} />
         <Route path="vendors/eventPreview" element={<EventPreview />} />
         <Route path="vendors/ViewDetails" element={<ViewDetails />} />
         <Route path="vendors/previewCompany" element={<CompanyPreview />} />
         <Route path="vendors/previewHospital" element={<HospitalPreview />} />
      </Routes>
    </Suspense>
  );
};

export default EnquiriesModule;
